/**
 * Formats input string to USD, sans '$' prefix
 * @param {string} str
 */
const numberToUSD = str => {
  if (str) {
    str = str.toString().replace(/\$/g, '').replace(/,/g, '');
    const formatter = new Intl.NumberFormat('en-US', {
      currency: 'USD',
      minimumFractionDigits: 0,
      style: 'currency'
    });

    return (str === '' || isNaN(str)) ? str : formatter.format(str);
  }
  return '$';
};

/**
 * Returns $0 for output less than 1
 * @param {string} str
 */
const formatOutputCurrency = str => {
  if (+str < 1) {
    return '$0';
  } else if (str >= 1000000) {
    str = Math.round(str / 1000000);
    return numberToUSD(str) + ' million';
  } else {
    return numberToUSD(str);
  }
};

/**
 * Returns URL for form submit
 * @param {object} state - Calculator state
 */
const resultsURLFromState = state => {
  let url = window.location.origin + window.hcdeBaseURL;
  url = new URL(url + `results/hcde-tax-calculator-results-${state.monthlyAmount}-a-month/`);

  let paramData = [
    ['propertyValue', state.propertyValue],
    ['teacherPay', state.teacherPay],
    ['artTeachers', state.artTeachers],
    ['instructionalSupport', state.instructionalSupport],
    ['apCredits', state.apCredits],
    ['schoolMaintenance', state.schoolMaintenance],
    ['countyCurrent', state.countyCurrent],
    ['countyProposed', state.countyProposed],
    ['myAmount', state.myAmount],
    ['myBudget', state.myBudget],
    ['monthlyAmount', state.monthlyAmount]
  ];

  paramData.forEach(p => {
    url = new URL(url);
    url.searchParams.set(p[0], p[1]);
  });

  url += '#calculator-results';

  return url;
};

export {numberToUSD, formatOutputCurrency, resultsURLFromState};
